membershipApp.controller('ScheduleController', ['$scope', '$http', '$timeout', '$translate', '$filter', '$compile', function ($scope, $http, $timeout, $translate, $filter, $compile) {

	$scope.text = 'me@example.com';
	$scope.emailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	// Default variables

	var now = new Date();
	var dd = now.getDate();
	var mm = now.getMonth() + 1;
	var yyyy = now.getFullYear();
	var nextYear = now.getFullYear() + 1;

	$scope.visitArea = 0;
	$scope.visitInstructor = 0;
	$scope.nameInstructor;
	$scope.choosenInstructor = false;
	$scope.filterActivity = filterActivity;
	$scope.nameActivity;
	$scope.choosenActivity = false;
	$scope.modalLoading = false;
	$scope.emptySchedule = false;
	$scope.activityId = null;
	$scope.peopleWaiting = 0;
	$scope.smodal = {paymentMethod: null, email: ''};
	$scope.paymentElavon= {};
	var $translateThis = $filter('translate');
	// if ( lang == null ){
	// 	lang = 'en';
	// }

	// Finding TimeZone Offset
	const timeZones = ["Europe/Andorra","Asia/Dubai","Asia/Kabul","Europe/Tirane","Asia/Yerevan","Antarctica/Casey","Antarctica/Davis","Antarctica/DumontDUrville","Antarctica/Mawson","Antarctica/Palmer","Antarctica/Rothera","Antarctica/Syowa","Antarctica/Troll","Antarctica/Vostok","America/Argentina/Buenos_Aires","America/Argentina/Cordoba","America/Argentina/Salta","America/Argentina/Jujuy","America/Argentina/Tucuman","America/Argentina/Catamarca","America/Argentina/La_Rioja","America/Argentina/San_Juan","America/Argentina/Mendoza","America/Argentina/San_Luis","America/Argentina/Rio_Gallegos","America/Argentina/Ushuaia","Pacific/Pago_Pago","Europe/Vienna","Australia/Lord_Howe","Antarctica/Macquarie","Australia/Hobart","Australia/Melbourne","Australia/Sydney","Australia/Broken_Hill","Australia/Brisbane","Australia/Lindeman","Australia/Adelaide","Australia/Darwin","Australia/Perth","Australia/Eucla","Asia/Baku","America/Barbados","Asia/Dhaka","Europe/Brussels","Europe/Sofia","Atlantic/Bermuda","Asia/Brunei","America/La_Paz","America/Noronha","America/Belem","America/Fortaleza","America/Recife","America/Araguaina","America/Maceio","America/Bahia","America/Sao_Paulo","America/Campo_Grande","America/Cuiaba","America/Santarem","America/Porto_Velho","America/Boa_Vista","America/Manaus","America/Eirunepe","America/Rio_Branco","America/Nassau","Asia/Thimphu","Europe/Minsk","America/Belize","America/St_Johns","America/Halifax","America/Glace_Bay","America/Moncton","America/Goose_Bay","America/Blanc-Sablon","America/Toronto","America/Nipigon","America/Thunder_Bay","America/Iqaluit","America/Pangnirtung","America/Atikokan","America/Winnipeg","America/Rainy_River","America/Resolute","America/Rankin_Inlet","America/Regina","America/Swift_Current","America/Edmonton","America/Cambridge_Bay","America/Yellowknife","America/Inuvik","America/Creston","America/Dawson_Creek","America/Fort_Nelson","America/Whitehorse","America/Dawson","America/Vancouver","Indian/Cocos","Europe/Zurich","Africa/Abidjan","Pacific/Rarotonga","America/Santiago","America/Punta_Arenas","Pacific/Easter","Asia/Shanghai","Asia/Urumqi","America/Bogota","America/Costa_Rica","America/Havana","Atlantic/Cape_Verde","America/Curacao","Indian/Christmas","Asia/Nicosia","Asia/Famagusta","Europe/Prague","Europe/Berlin","Europe/Copenhagen","America/Santo_Domingo","Africa/Algiers","America/Guayaquil","Pacific/Galapagos","Europe/Tallinn","Africa/Cairo","Africa/El_Aaiun","Europe/Madrid","Africa/Ceuta","Atlantic/Canary","Europe/Helsinki","Pacific/Fiji","Atlantic/Stanley","Pacific/Chuuk","Pacific/Pohnpei","Pacific/Kosrae","Atlantic/Faroe","Europe/Paris","Europe/London","Asia/Tbilisi","America/Cayenne","Africa/Accra","Europe/Gibraltar","America/Nuuk","America/Danmarkshavn","America/Scoresbysund","America/Thule","Europe/Athens","Atlantic/South_Georgia","America/Guatemala","Pacific/Guam","Africa/Bissau","America/Guyana","Asia/Hong_Kong","America/Tegucigalpa","America/Port-au-Prince","Europe/Budapest","Asia/Jakarta","Asia/Pontianak","Asia/Makassar","Asia/Jayapura","Europe/Dublin","Asia/Jerusalem","Asia/Kolkata","Indian/Chagos","Asia/Baghdad","Asia/Tehran","Atlantic/Reykjavik","Europe/Rome","America/Jamaica","Asia/Amman","Asia/Tokyo","Africa/Nairobi","Asia/Bishkek","Pacific/Tarawa","Pacific/Enderbury","Pacific/Kiritimati","Asia/Pyongyang","Asia/Seoul","Asia/Almaty","Asia/Qyzylorda","Asia/Qostanay","Asia/Aqtobe","Asia/Aqtau","Asia/Atyrau","Asia/Oral","Asia/Beirut","Asia/Colombo","Africa/Monrovia","Europe/Vilnius","Europe/Luxembourg","Europe/Riga","Africa/Tripoli","Africa/Casablanca","Europe/Monaco","Europe/Chisinau","Pacific/Majuro","Pacific/Kwajalein","Asia/Yangon","Asia/Ulaanbaatar","Asia/Hovd","Asia/Choibalsan","Asia/Macau","America/Martinique","Europe/Malta","Indian/Mauritius","Indian/Maldives","America/Mexico_City","America/Cancun","America/Merida","America/Monterrey","America/Matamoros","America/Mazatlan","America/Chihuahua","America/Ojinaga","America/Hermosillo","America/Tijuana","America/Bahia_Banderas","Asia/Kuala_Lumpur","Asia/Kuching","Africa/Maputo","Africa/Windhoek","Pacific/Noumea","Pacific/Norfolk","Africa/Lagos","America/Managua","Europe/Amsterdam","Europe/Oslo","Asia/Kathmandu","Pacific/Nauru","Pacific/Niue","Pacific/Auckland","Pacific/Chatham","America/Panama","America/Lima","Pacific/Tahiti","Pacific/Marquesas","Pacific/Gambier","Pacific/Port_Moresby","Pacific/Bougainville","Asia/Manila","Asia/Karachi","Europe/Warsaw","America/Miquelon","Pacific/Pitcairn","America/Puerto_Rico","Asia/Gaza","Asia/Hebron","Europe/Lisbon","Atlantic/Madeira","Atlantic/Azores","Pacific/Palau","America/Asuncion","Asia/Qatar","Indian/Reunion","Europe/Bucharest","Europe/Belgrade","Europe/Kaliningrad","Europe/Moscow","Europe/Simferopol","Europe/Kirov","Europe/Volgograd","Europe/Astrakhan","Europe/Saratov","Europe/Ulyanovsk","Europe/Samara","Asia/Yekaterinburg","Asia/Omsk","Asia/Novosibirsk","Asia/Barnaul","Asia/Tomsk","Asia/Novokuznetsk","Asia/Krasnoyarsk","Asia/Irkutsk","Asia/Chita","Asia/Yakutsk","Asia/Khandyga","Asia/Vladivostok","Asia/Ust-Nera","Asia/Magadan","Asia/Sakhalin","Asia/Srednekolymsk","Asia/Kamchatka","Asia/Anadyr","Asia/Riyadh","Pacific/Guadalcanal","Indian/Mahe","Africa/Khartoum","Europe/Stockholm","Asia/Singapore","America/Paramaribo","Africa/Juba","Africa/Sao_Tome","America/El_Salvador","Asia/Damascus","America/Grand_Turk","Africa/Ndjamena","Indian/Kerguelen","Asia/Bangkok","Asia/Dushanbe","Pacific/Fakaofo","Asia/Dili","Asia/Ashgabat","Africa/Tunis","Pacific/Tongatapu","Europe/Istanbul","America/Port_of_Spain","Pacific/Funafuti","Asia/Taipei","Europe/Kiev","Europe/Uzhgorod","Europe/Zaporozhye","Pacific/Wake","America/New_York","America/Detroit","America/Kentucky/Louisville","America/Kentucky/Monticello","America/Indiana/Indianapolis","America/Indiana/Vincennes","America/Indiana/Winamac","America/Indiana/Marengo","America/Indiana/Petersburg","America/Indiana/Vevay","America/Chicago","America/Indiana/Tell_City","America/Indiana/Knox","America/Menominee","America/North_Dakota/Center","America/North_Dakota/New_Salem","America/North_Dakota/Beulah","America/Denver","America/Boise","America/Phoenix","America/Los_Angeles","America/Anchorage","America/Juneau","America/Sitka","America/Metlakatla","America/Yakutat","America/Nome","America/Adak","Pacific/Honolulu","America/Montevideo","Asia/Samarkand","Asia/Tashkent","America/Caracas","Asia/Ho_Chi_Minh","Pacific/Efate","Pacific/Wallis","Pacific/Apia","Africa/Johannesburg","America/Antigua","America/Anguilla","Africa/Luanda","Antarctica/McMurdo","America/Aruba","Europe/Mariehamn","Europe/Sarajevo","Africa/Ouagadougou","Asia/Bahrain","Africa/Bujumbura","Africa/Porto-Novo","America/St_Barthelemy","America/Kralendijk","Africa/Gaborone","Africa/Kinshasa","Africa/Lubumbashi","Africa/Bangui","Africa/Brazzaville","Africa/Douala","Europe/Busingen","Africa/Djibouti","America/Dominica","Africa/Asmara","Africa/Addis_Ababa","Africa/Libreville","America/Grenada","Europe/Guernsey","Africa/Banjul","Africa/Conakry","America/Guadeloupe","Africa/Malabo","Europe/Zagreb","Europe/Isle_of_Man","Europe/Jersey","Asia/Phnom_Penh","Indian/Comoro","America/St_Kitts","Asia/Kuwait","America/Cayman","Asia/Vientiane","America/St_Lucia","Europe/Vaduz","Africa/Maseru","Europe/Podgorica","America/Marigot","Indian/Antananarivo","Europe/Skopje","Africa/Bamako","Pacific/Saipan","Africa/Nouakchott","America/Montserrat","Africa/Blantyre","Africa/Niamey","Asia/Muscat","Africa/Kigali","Atlantic/St_Helena","Europe/Ljubljana","Arctic/Longyearbyen","Europe/Bratislava","Africa/Freetown","Europe/San_Marino","Africa/Dakar","Africa/Mogadishu","America/Lower_Princes","Africa/Mbabane","Africa/Lome","Africa/Dar_es_Salaam","Africa/Kampala","Pacific/Midway","Europe/Vatican","America/St_Vincent","America/Tortola","America/St_Thomas","Asia/Aden","Indian/Mayotte","Africa/Lusaka","Africa/Harare" ]

	let timezoneP = timeZone.split(') ');
	let timezonePi = timezoneP[1].split(',');
	let timeZoneC = timezonePi[0];
	let timeZoneF = timeZones.find(el => el.includes(timeZoneC)); 

	let timeZoneOffsetSplit = timezoneP[0].split('UTC');
	$scope.timeZoneOffset = timeZoneOffsetSplit[1];

	moment.tz.setDefault(timeZoneF);

	if ( lang ){
		$translate.use(lang);
	}else{
		lang = $translate.proposedLanguage() || $translate.use();
	}


	function alignModal(){
        var modalDialog = $(this).find(".modal-dialog");
        
        // Applying the top margin on modal to align it vertically center
        modalDialog.css("margin-top", Math.max(0, ($(window).height() - modalDialog.height()) / 2));
    }
    // Align modal when it is displayed
    $(".modal").on("shown.bs.modal", alignModal);
    
    // Align modal when user resize the window
    $(window).on("resize", function(){
        $(".modal:visible").each(alignModal);
    });   

	$scope.lang = lang;

	$scope.paymentMethods = new Array("OnSide", "Membership", "Sodexo", "MultiSport", "Voucher", "EPay", "PaySafe");

	if (settings) {
		$scope.classSettings = settings;

		if($scope.classSettings.ShowScheduleDaysAhead > 0 ){
			let date = new Date($scope.scheduleStartDate);
			date.setDate(date.getDate() + $scope.classSettings.ShowScheduleDaysAhead);
			date = new Date(date);

			let dd = date.getDate();
			let mm = date.getMonth() + 1;
			let yyyy = date.getFullYear();

			$scope.scheduleEndDate = mm + '/' + dd + '/' + yyyy;
		}
	}

	if (dd < 10) {
		dd = '0' + dd
	}

	if (mm < 10) {
		mm = '0' + mm
	}

	today = mm + '/' + dd + '/' + yyyy;
	todayInOneYear = mm + '/' + dd + '/' + nextYear;

	var schedule_from = $("#schedule_from");
	var schedule_to = $("#schedule_to");
	$scope.scheduleStartDate = today;
	$scope.scheduleEndDate = todayInOneYear;

	if ( $scope.mobileApp ){
		$scope.scheduleStartDate = new Date(today);
		$scope.scheduleEndDate = new Date(todayInOneYear);
	}

	function findElement(arr, propName, propValue) {
		for (var i = 0; i < arr.length; i++)
			if (arr[i][propName] == propValue)
				return arr[i];
		// will return undefined if not found; you could return a default instead
	}

	function getClientWaitingList(data) {
		let scheduleData = data;
		var dataObject = {
			Namespace: namespace,
			Email: $scope.client.Email
		}
		$http({
			method: 'POST',
			url:'/ScheduleV2/GetClientWaitingList',
			data: dataObject
		}).success(function (data) {
			
			let allData = scheduleData.concat(data);
			
			if ( allData.length == 0 ) {
				$scope.noEvents = true;
				$scope.clientSchedule = {};
			}
			else{
				$scope.noEvents = false;
				var today = new Date();
				$scope.testData = [];
				angular.copy(allData, $scope.testData);
				for (var i = 0; i < $scope.testData.length; ++i) {
					var DateNewDate = moment($scope.testData[i]['Date']);
					var DateNewDateEnd = moment($scope.testData[i]['DateEnd']);

					var isDstChangeDay = moment(DateNewDate).isDST();
					if ( isDstChangeDay ){
						DateNewDate = moment(DateNewDate).add(1, 'hours');
						DateNewDateEnd = moment(DateNewDateEnd).add(1, 'hours');
					}

					var convertedDate = DateNewDate.toString();
					var convertedDateEnd = DateNewDateEnd.toString();
					var x = findElement($scope.schedule_areas, "AreaID", $scope.testData[i]['AreaID']);

					$scope.testData[i]['NewDate'] = moment(convertedDate).toDate();
					$scope.testData[i]['NewDateEnd'] = moment(convertedDateEnd).toDate();
					if (x != undefined && x['Name'] != undefined)
					    $scope.testData[i]['AreaName'] = x['Name'];

				}

				$scope.testData = $scope.convertTo($scope.testData, 'Date', true);

				$scope.clientSchedule = {};
				Object.keys($scope.testData).sort().forEach(function (key) {
					$scope.clientSchedule[key] = $scope.testData[key];
				});
			}
		}).error(function () {

		});
	}


	$scope.getClientServices = function (client) {
		// console.log(client);
		let clientID = $scope.client.ClientID
		if(client){
			let clientGroupMember = JSON.parse(client);
			// console.log(clientGroupMember);
			clientID = clientGroupMember.ClientID;
		}



		var dataObject = {
			Namespace: namespace,
			ClientID: clientID,
			datestart: moment($scope.scheduleStartDate),
			dateend: moment($scope.scheduleEndDate)
		}
		$http({
			method: 'POST',
			url:'/private/GetClientScheduleByClientID',
			data: dataObject
		}).success(function (data) {
			getClientWaitingList(data);
		}).error(function () {

		});
	}

	$scope.beforLeaveEvent = function(visitDate, visitId, waitingID) {
		$scope.currentVisitDate = visitDate;
		$scope.currentVisitID = visitId;
		$scope.currentWaitingID = waitingID;
		$('#cancelEventModal').modal('show');
	}

	// public ContentResult RemoveFromWaitingList(string Namespace, string Email, int WaitingListID)

	$scope.leaveLink = function(){
		if($scope.currentWaitingID > 0){
			leaveWaitingList();
		}else{
			leaveEvent();
		}
	}

	function leaveWaitingList(){
		var dataObject = {
			Namespace: namespace,
			Email: $scope.client.Email,
			WaitingListID: $scope.currentWaitingID,
		}

		let successText = $translateThis('You are successfully removed from the waiting list');
		let errorText = $translateThis('You can not be removed from the waiting list');

		$http({
			method: 'POST',
			url: '/ScheduleV2/RemoveFromWaitingList',
			data: dataObject
		}).success(function (data) {
			if (data == true || data == 'True') {
				Swal.fire({
					type: 'success',
					title: successText,
					onAfterClose: function (){
						$scope.getClientServices();
						$scope.closePopup()
					}
				});
			}else{
				Swal.fire({
					type: 'waring',
					title: errorText,
					onAfterClose: () => $scope.closePopup()
				});
			}
		}).error(function () {
			
		});
	}
	function leaveEvent() {
		var now = new Date();

		var dateBeforeCancel = new Date($scope.currentVisitDate);
		dateBeforeCancel.setHours(dateBeforeCancel.getHours() - $scope.classSettings.HoursBeforeCanceling);
		let translated = $translateThis('You succesfuly cancel this event');
		let translatedError = $translateThis('You can not cancel this event now!');

		if (now < dateBeforeCancel) {
			var dataObject = {
				Namespace: namespace,
				GymID: gymid,
				Id: $scope.currentVisitID,
				ClientID: $scope.client.ClientID
			}

			if($scope.clientGroupMemberSel){
				let clientGroupMember = JSON.parse($scope.clientGroupMemberSel);
				dataObject.ClientID = clientGroupMember.ClientID
			}

			$http({
				method: 'POST',
				url: '/private/leaveEvent',
				data: dataObject
			}).success(function (data) {
				if (data == true || data == 'True') {
					Swal.fire({
						type: 'success',
						title: translated,
						onAfterClose: function (){
							if($scope.clientGroupMemberSel){
								$scope.getClientServices($scope.clientGroupMemberSel);
							}else{
								$scope.getClientServices();
							}
							$('#cancelEventModal').modal('hide')
						}
					});
				}else{
					Swal.fire({
						type: 'warning',
						title: translatedError
					});
				}
			}).error(function () {
				Swal.fire({
					type: 'warning',
					title: translatedError
				});
			});
		} else {
			Swal.fire({
				type: 'warning',
				title: translatedError
			});
		}
	}

	$scope.getEventsType = function(dgymID){
		if ( dgymID ) {
			gymid = dgymID;
		}

		var dataObject = {
			Namespace: namespace,
			GymId: gymid
		}
		$http({
			method: 'GET',
			url: '/api/public/GetPublicEvents?nameSpace=' + namespace + '&gymId=' + gymid,
			data: dataObject
		}).success(function (data) {
			$scope.schedule_activities = data;
		}).error(function () {

		});
	}
	$scope.getEventsType();
 

	// Get Schedule

	$scope.getSchedule = function (from, to, dgymID, dontUpdateActInstr) {
		var updateActInstr = true;
		$scope.emptySchedule = false;

		if ( dontUpdateActInstr != undefined ){
			updateActInstr = false;
		}

		if ( dgymID ) {
			gymid = dgymID;
		}

		var dataObject = {
			GymID: gymid,
			Namespace: namespace,
			DateStart: $scope.scheduleStartDate,
			DateEnd: $scope.scheduleEndDate,
			AreaID: $scope.visitArea,
			InstructorID: $scope.visitInstructor,
			Private: true,
			PublicEventID: $scope.activityId
		}

		$http({
			method: 'POST',
			url: '/api/public/GetSchedule',
			data: dataObject
		}).success(function (data) {
			var today = new Date();
			$scope.testData = [];
			var currentActivities = [];
			var currentInstructors = [];
			$scope.Schedule = {};

			if(data.length > 0){
				$scope.emptySchedule = false;
				angular.copy(data, $scope.testData);
				for (var i = 0; i < $scope.testData.length; ++i) {
					var DateNewDate = moment($scope.testData[i]['Date']);
					var DateNewDateEnd = moment($scope.testData[i]['DateEnd']);

					var isDstChangeDay = moment(DateNewDate).isDST();
					if ( isDstChangeDay ){
						DateNewDate = moment(DateNewDate).add(1, 'hours');
						DateNewDateEnd = moment(DateNewDateEnd).add(1, 'hours');
					}
					var convertedDate = DateNewDate.toString();
					var convertedDateEnd = DateNewDateEnd.toString();

					var x = findElement($scope.schedule_areas, "AreaID", $scope.testData[i]['AreaID']);

					$scope.testData[i]['NewDate'] = moment(convertedDate).toDate();
					$scope.testData[i]['NewDateEnd'] = moment(convertedDateEnd).toDate();
					if (x != undefined && x['Name'] != undefined)
						$scope.testData[i]['AreaName'] = x['Name'];

					$scope.testData[i]['ShowParticipantsCount'] = x != undefined ? x['ShowParticipantsCount'] : false;

					var testDateBeforeBooking = new Date($scope.testData[i]['Date']);
					testDateBeforeBooking.setHours(moment($scope.testData[i]['Date']).hours() - $scope.classSettings.HoursBeforeBooking);
					$scope.testData[i]['HoursBeforeBooking'] = testDateBeforeBooking;

					if($scope.testData[i]['Color'].length > 7){
						let firstTwo = $scope.testData[i]['Color'].slice(1, 3);
						let mainColor = $scope.testData[i]['Color'].slice(3, 9);
						let newColor = '#'+mainColor+firstTwo;
						$scope.testData[i]['Color'] = newColor;
					}

					var testDatedaysAheadBooking = new Date(convertedDate);
					testDatedaysAheadBooking.setDate(testDatedaysAheadBooking.getDate() - $scope.classSettings.DaysAheadBooking);

					if (today >= testDatedaysAheadBooking || $scope.classSettings.DaysAheadBooking == 0) {
						$scope.testData[i]['AheadBooking'] = true;
					} else {
						$scope.testData[i]['AheadBooking'] = false;
					}

					if ( $scope.testData[i]['PeopleAttending'] >= $scope.testData[i]['MaxClients']) {
						$scope.testData[i]['FullCapacity'] = true;
					}else{
						$scope.testData[i]['FullCapacity'] = false;
					}

					$scope.testData[i]['SlotsLeft'] = $scope.testData[i]['MaxClients'] - $scope.testData[i]['PeopleAttending'];

					// console.log($scope.testData[i]);
					if ( updateActInstr == true ){
						if ( !currentActivities.includes($scope.testData[i]['PublicEventID']) ) {
							currentActivities.push($scope.testData[i]['PublicEventID']);
						}
					}

					if ( $scope.testData[i]['InstructorIDs'] != null ) {
						var manageInstrucors = $scope.testData[i]['InstructorIDs'];

						if ( manageInstrucors.indexOf(',') > -1 ) {
							var res = manageInstrucors.split(',');

							for (var n = 0; n < res.length; n++) {
								if ( !currentInstructors.includes(res[n]) ) {
									currentInstructors.push(res[n]);
								}

								var result = $.grep($scope.schedule_instructors, function (e) { return e.Id == res[n] });
								if ( result.length > 0 ) {
									var instructor = result[0].Name;
									if ( n > 0 ) {
										instructor = ', ' + instructor;
									}
									$scope.testData[i]['Instructors']  += instructor;
								}
							}
						}else{
							if ( !currentInstructors.includes(manageInstrucors) && manageInstrucors != '00000000-0000-0000-0000-000000000000' && manageInstrucors != '' ) {
								currentInstructors.push(manageInstrucors);
							}

							var result = $.grep($scope.schedule_instructors, function (e) { return e.Id == manageInstrucors });
							if ( result.length > 0 ) {
								$scope.testData[i]['Instructors'] = result[0].Name;
							}
						}
					}
				}

				if ( updateActInstr == true ){
					getCurrentActivities(currentActivities);
					getCurrentInstructors(currentInstructors);
				}

				$scope.originalData = $scope.testData;
				$scope.testData = $scope.convertTo($scope.testData, 'Date', true);

				$scope.Schedule = {};
				Object.keys($scope.testData).sort().forEach(function (key) {
					$scope.Schedule[key] = $scope.testData[key];
				});

				$('body').addClass('loaded');
			}else{
				$scope.emptySchedule = true;
				$('body').addClass('loaded');
			}
			

		}).error(function () {

		});
	}

	function getCurrentActivities(array){
		$scope.current_activities = [];

		for (var i = 0; i < array.length; i++) {
			var activity = array[i];
			var result = $.grep($scope.schedule_activities, function (e) { return e.Id == activity });

			if ( result.length > 0 ) {
				$scope.current_activities.push(result[0]);
			}
		}
	}

	function getCurrentInstructors(array){
		$scope.current_instructors = [];

		for (var i = 0; i < array.length; i++) {
			var instructor = array[i];
			var result = $.grep($scope.schedule_instructors, function (e) { return e.Id == instructor });

			if ( result.length > 0 ) {
				$scope.current_instructors.push(result[0]);
			}
		}
	}

	$scope.convertTo = function (arr, key, dayWise) {
		var groups = {};
		for (var i = 0; l = arr.length, i < l; i++) {
			var newDateLocal = new Date(arr[i][key]).toISOString().slice(0, 10);
			// console.log(newDateLocal);

			arr[i]['DateLocal'] = new Date(arr[i][key]).toISOString().slice(0, 10);

			groups[arr[i]['DateLocal']] = groups[arr[i]['DateLocal']] || [];
			groups[arr[i]['DateLocal']].push(arr[i]);
		}
		return groups;
	};

	$scope.updateActivity = function (activityId) {
		$('body').removeClass('loaded');
		$scope.activityId = activityId;
		$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, gymid, 'dontUpdateActInstr');
		if (activityId != null) {
			var x = findElement($scope.schedule_activities, "Id", activityId);

			$scope.choosenActivity = true;
			$scope.nameActivity = x['Name'];
		} else {
			$scope.choosenActivity = false;
		}

		// $('.schedule-wrapper .filter-section .filter-col-activities .dd').removeClass('show');
	}


	// Get Areas

	$scope.getAreas = function (gymid, allAreas) {
		var dataObject = {
			Namespace: namespace,
			GymId: gymid,
			AllAreas: false
		}

		if ( allAreas ) {
			dataObject = {
				Namespace: namespace,
				GymId: gymid,
				AllAreas: true
			}
		}


		$http({
			method: 'GET',
			url: '/api/public/GetAreas?AllAreas=' + allAreas + '&nameSpace=' + namespace + '&gymId=' + gymid,
			data: dataObject
		}).success(function (data) {
			$scope.schedule_areas = data;
		}).error(function () {

		});
	}

	$scope.updateAreaId = function (id, gymID) {
		$('body').removeClass('loaded');
		$('.filter-col-activities input:checked').prop('checked', false);
		$scope.choosenActivity = false;
		$scope.scheduleActivity = null;
		$scope.activityId = null;
		$('.filter-col-instructors input:checked').prop('checked', false);
		$scope.visitInstructor = 0;
		$scope.choosenInstructor = false;
		$scope.scheduleActivity = 'null';
		$scope.scheduleInstructor = '0';
		$scope.visitArea = id;
		if ( gymID ) {
			$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, gymID);
		}else{
			$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate);
		}
	}

	// Get Instructors
	$scope.getInstructors = function (gymid) {
		var dataObject = {
			Namespace: namespace,
			GymId: gymid
		}
		$http({
			method: 'GET',
			url: '/api/public/GetInstructors?nameSpace=' + namespace + '&gymId=' + gymid,
			data: dataObject
		}).success(function (data) {
			$scope.schedule_instructors = data;
		}).error(function () {

		});
	}

	// Get Gyms
	$scope.getGyms = function () {
		var dataObject = {
			Namespace: namespace
		}
		$http({
			method: 'POST',
			url: '/Membership/GetGyms',
			data: dataObject
		}).success(function (data) {
			$scope.membershipGyms = data;

			if ($scope.membershipGyms.length > 1 && $('.schedule-wrapper-main').length ) {
				$('.schedule-wrapper-main').addClass('loading');
				$scope.getAreas(gymid, false);
			} else {
				$scope.getAreas(gymid, true);
				setTimeout(function () {
					$scope.getSchedule(today, todayInOneYear, gymid);
					// $scope.getClientServices();
					getClientMembership();
				}, 100);
				$scope.getInstructors(gymid);
				$scope.getSettings(gymid);
			}

		}).error(function () {
			// console.log('error');
		});
	}

	$(window).on('load', function () {
		if (clientModel) {
			$scope.client = clientModel.Client;
		}else if ($scope.Client){
			$scope.client = $scope.Client;
		}

		$scope.getGyms();
	})

	$scope.changeScheduleZone = function () {
		var id = $scope.scheduleZone;
		var x = findElement($scope.membershipGyms, "GymID", id);
		$scope.scheduleZoneName = x.GymName;
		$scope.choosenActivity = false;
		$scope.scheduleActivity = null;
		$scope.activityId = null

		$('.filter-col-instructors input:checked').prop('checked', false);
		$scope.choosenInstructor = false;
		$scope.visitInstructor = 0;

		$scope.scheduleActivity = 'null';
		$scope.scheduleInstructor = '0';
		$scope.scheduleArea = '0';

		$scope.getAreas(id, false);
		$scope.getInstructors(id);
		$scope.getSettings(id);
		$scope.getEventsType(id);

		setTimeout(function () {
			$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, id);

			if (days != null) {
				$('.schedule-list').addClass('hide');
				for (var i = 0; i < days; i++) {
					$('.schedule-list .list-item').eq(i).addClass('show');
				}
			}

			$('.schedule-wrapper-main').removeClass('loading');
		}, 500);

	}

	$scope.getSettings = function (id) {
		var dataObject = {
		    Namespace: namespace,
		    GymID: id
		}
		$http({
			method: 'POST',
			url: '/ScheduleV2/GetSettings',
			data: dataObject
		}).success(function (data) {
			$scope.classSettings = data;
			// $scope.classSettings.ShowCapacityCustomersPortal = true;

			$scope.showCapacity = data.ShowCapacityCustomersPortal;
			$scope.showInstructor = data.ShowInstructorCustomersPortal;

			if($scope.classSettings.ShowScheduleDaysAhead > 0 ){
				let date = new Date($scope.scheduleStartDate);
				date.setDate(date.getDate() + $scope.classSettings.ShowScheduleDaysAhead);
				date = new Date(date);

				let dd = date.getDate();
				let mm = date.getMonth() + 1;
				let yyyy = date.getFullYear();

				$scope.scheduleEndDate = mm + '/' + dd + '/' + yyyy;
			}
		}).error(function () {
			// console.log('error');
		});
	}

	$scope.updateInstructorId = function (id) {
		$scope.visitInstructor = id;

		$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, gymid, 'dontUpdateActInstr');

		if (id != '0') {
			var x = findElement($scope.schedule_instructors, "Id", id);

			$scope.choosenInstructor = true;
			$scope.nameInstructor = x['Name'];
		} else {
			$scope.choosenInstructor = false;
		}

		// $('.schedule-wrapper .filter-section .dd').removeClass('show');
	}

	$scope.updateVisitProduct = function(id){
		if ( id != '-1') {
			var result = $.grep($scope.visitProducts, function (e) { return e.ProductID == id });
			$scope.productId = id;
			$scope.productName = result[0].ProductName;
		}else{
			$scope.productId = '-1';
			$scope.productName = 'Own equipment'
		}
	}

	// Join Event

	$scope.paymentChange = function(){
		if ($scope.smodal.paymentMethod == '7') {

			generatePaymentIntent();
		}else{
			// $('.popup-wrapper .popup .stripe-button').removeClass('show');
		}
	}

	$scope.modalEventLink = function(){
		$scope.loading = true;
		if ($scope.smodal.paymentMethod == '7') {
			stripeConfirmPayment();
		}else{
			$scope.joinEvent();
		}
	}

	// Generate PaymentInted for Stripe
	function generatePaymentIntent() {
		$scope.PaymentIntentID = 0;
		let dataObject = prepareDataToSned();

		if ($scope.formLoaded == true) {
			$scope.formLoaded = false;
			$http({
				method: 'POST',
				url: '/private/GeneratePaymentIntent',
				data: dataObject
			}).success(function (data) {

				if(data == 'Waiver Required!'){
					var translated = $translateThis('Waiver Required!Portal');
					var waiverHref = window.location.origin + '/waiver/embedregistration?GymID=' + gymid + '&NameSpace=' + namespace + '&Redirect=/account/embedgroupschedule';
					Swal.fire({
						type: 'warning',
						title: translated,
						showCancelButton: true,
					}).then(function(result) {
						if (result.value) {
							window.location.href = waiverHref;
						}else{
							$timeout(function() {
								$scope.formLoaded = true;
								$scope.loading = false;
							});
						}
					});
				}else if(data == 'Customer banned from booking!'){
					let translated = $translateThis('Your access to the booking system has been suspended due to non-compliance with the rules of the sports center. Please contact reception.');
					
					if($scope.Client.BanBooking && $scope.unBanPrice > 0){
						Swal.fire({
							type: 'warning',
							title: translated,
							showCancelButton: true,
							confirmButtonText: 'Unban',
						}).then((result) => {
							/* Read more about isConfirmed, isDenied below */
							if (result.value) {
								$('#unBanModal').modal('show')
							}
						})
					}else{
						Swal.fire({
							type: 'warning',
							title: translated
						});
					}
					$scope.formLoaded = true;
					$scope.loading = false;
				}else if( data == 2 ){
					let translated = $translateThis(joinEventResponses[data]);
					Swal.fire({
						type: 'warning',
						title: translated
					});
					$scope.formLoaded = true;
					$scope.loading = false;
				}else{
					$scope.BookingOrderID = data.BookingOrderID;
					$scope.PaymentIntentID = data.ID;
					stripeInitialize(data);
					$scope.formLoaded = true;
					
				}
			}).error(function (error) {
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated
				});
				$scope.formLoaded = true;
				$scope.loading = false;
			});
		}
	}

	function stripeInitialize(data){
		$scope.stripe = Stripe($scope.classSettings.StripePublishKey, {
			betas: ['mb_way_pm_beta_1'],
		});
		
		const options = {
			clientSecret: data.ClientSecret,
			appearance: {/*...*/},
		};
		let clientName = $scope.Client.FirstName + ' ' + $scope.Client.LastName;

		$scope.stripeElements = $scope.stripe.elements(options);
		$scope.stripeError = document.getElementById('error-message');
		const paymentElementOptions = { 
			layout: 'accordion',
			fields: {
				billingDetails: {
					address: {
						postalCode: $scope.classSettings.HidePostalCode ? 'never' : 'auto'
					}
				}
			},
			defaultValues: {
				billingDetails: {
					name: clientName,
					email: 'never',
                    phone: 'never'
				}
			}
		};
		const paymentElement = $scope.stripeElements.create('payment', paymentElementOptions);
		paymentElement.mount('#payment-element');
		$scope.loading = false;
	}

	function stripeConfirmPayment(){
		if (!$scope.stripe || !$scope.stripeElements) return;
		$scope.loading = true;

		$scope.stripe.confirmPayment({
			elements: $scope.stripeElements,
			redirect: 'if_required',
		}).then(function(result) {
			var error = result.error;
			var paymentIntent = result.paymentIntent;

			console.log(result);

			if (error) {
				$timeout(function() {
					$scope.loading = false;
					if ($scope.stripeError) $scope.stripeError.textContent = error.message;
				});
			} else {
				switch (paymentIntent.status) {
				case 'succeeded':
					// $scope.placeOrder(true);
					$scope.joinEvent();
					break;
				case 'requires_payment_method':
					$timeout(function() {
						$scope.loading = false;
						var msg = (paymentIntent.last_payment_error && paymentIntent.last_payment_error.message)
							? paymentIntent.last_payment_error.message
							: 'Payment failed. Please try another payment method.';
						var translatedMsg = $translateThis(msg);
						if ($scope.stripeError) $scope.stripeError.textContent = translatedMsg;
						Swal.fire({ type: 'warning', title: translatedMsg });
					});
					break;
				default:
					$timeout(function() {
						$scope.loading = false;
					});
					break;
				}
			}
		});
	}

	if($('.schedule-wrapper-main').length){
		$scope.$watch('clientGroupMemberSel', function (v) {
			if(v){
				var member = JSON.parse(v);;
				checkHasValidMembership(member);
				if($scope.modalVisit.AgeRestriction){
					checkAgeRestriction(member, true);
				}
			}
		});
	}

	function prepareDataToSned(){
		let dataObject = {
			Namespace: namespace,
			GymID: gymid,
			Id: $scope.modalVisit.ID,
			Email: $scope.Client.Email,
			FirstName: $scope.Client.FirstName,
			LastName: $scope.Client.LastName,
			Telephone: $scope.Client.Telephone,
			Date: moment($scope.modalVisit.NewDate).toISOString(),
			VisitName: $scope.modalVisit.VisitName,
			PaymentMethod: $scope.smodal.paymentMethod,
			Language: $scope.currentLang,
			ProductID: $scope.productId,
			ProductName: $scope.productName,
			PaymentIntentID: $scope.PaymentIntentID
		}

		if($scope.clientGroupMemberSel){
			let clientGroupMember = JSON.parse($scope.clientGroupMemberSel);
			dataObject.clientID = clientGroupMember.ClientID
		}

		if ( $scope.smodal.paymentMethod == '7' ) {
			dataObject.PaymentMethod = 7;
			dataObject.Token = $scope.token;
			dataObject.Price = $scope.modalPrice;
			dataObject.PublicEventID = $scope.PublicEventID;
			dataObject.OrderID = $scope.BookingOrderID
		}

		if ($scope.smodal.paymentMethod == '8') {
			dataObject.PaymentMethod = 8;
			dataObject.Price = $scope.modalPrice;
			dataObject.PublicEventID = $scope.PublicEventID;
		}

		if ($scope.smodal.paymentMethod == '9') {
			dataObject.PaymentMethod = 9;
			dataObject.Price = $scope.modalPrice;
			dataObject.PublicEventID = $scope.PublicEventID;
		}

		if ($scope.smodal.paymentMethod == '10') {
			dataObject.PaymentMethod = 10;
			dataObject.Price = $scope.modalPrice;
			dataObject.PublicEventID = $scope.PublicEventID;
		}

		if ($scope.smodal.paymentMethod == '11') {
			dataObject.PaymentMethod = 11;
			dataObject.Price = $scope.modalPrice;
			dataObject.PublicEventID = $scope.PublicEventID;
		}

		if ($scope.smodal.paymentMethod == '12') {
			dataObject.PaymentMethod = 12;
			dataObject.Price = $scope.modalPrice;
			dataObject.PublicEventID = $scope.PublicEventID;
		}

		if ($scope.smodal.paymentMethod == '13') {
			dataObject.PaymentMethod = 13;
			dataObject.Price = $scope.modalPrice;
			dataObject.PublicEventID = $scope.PublicEventID;
		}

		if($scope.smodal.paymentMethod == '11' && $scope.paymentElavon.ElavonOrderID){
			dataObject.OrderID = $scope.paymentElavon.ElavonOrderID;
			dataObject.ЕlavonTransactionID = $scope.paymentElavon.ElavonTransactionID;
			$scope.formLoaded = true;
		}

		return dataObject;
	}

	$scope.formLoaded = true;
	var joinEventResponses = new Array('joinEventResponse1', 'joinEventResponse2', 'joinEventResponse3', 'joinEventResponse4', 'joinEventResponse5', 'joinEventResponse6', 'joinEventResponse7', 'joinEventResponseEmpty','joinEventResponseEmpty', 'joinEventResponse8', 'joinEventResponse9', 'joinEventResponse10');

	$scope.joinEvent = function () {
		let dataObject = prepareDataToSned();

		if ($scope.formLoaded = true) {
		    $scope.formLoaded = false;
		    $http({
		        method: 'POST',
		        url: '/private/JoinEvent',
		        data: dataObject
		    }).success(function (data) {
		        // $scope.loading = false;
		        var responseI = data;
		        $scope.joinEventResponse = joinEventResponses[responseI];

		        if (responseI == 0) {

					if (dataObject.PaymentMethod == 8) {
						generateMyPos();
					}else if (dataObject.PaymentMethod == 9) {
						generatePaymob();
					}else if (dataObject.PaymentMethod == 10) {
						generateNetcash();
					}else if (dataObject.PaymentMethod == 12) {
						generateCpay();
					}else if (dataObject.PaymentMethod == 13) {
						generateXendit();
					}else{
						let translated = $translateThis($scope.joinEventResponse);
						Swal.fire({
							type: 'success',
							title: translated,
							onAfterClose: () => {
								$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, gymid);
								$scope.closePopup()
							}
						});
						$scope.loading = false;
					}
		        }else if (responseI == 11) {
					generateElavon();
		        }else if (responseI == 1) {
					if($scope.modalVisit.WaitingList){
						$('#waitingModal').modal('show');
					}else{
						let translated = $translateThis($scope.joinEventResponse);
						Swal.fire({
							type: 'warning',
							title: translated,
							onAfterClose: () => $scope.closePopup()
						});
					}
					$scope.loading = false;
					// console.log($scope.modalVisit);
					// $scope.joinWaitingList($scope.modalVisit);
					
					// $('#waiting-popup .popup, #waiting-popup').addClass('show');
		        }else if (responseI == 6) {
					let translated = $translateThis($scope.joinEventResponse);
					Swal.fire({
						type: 'warning',
						title: translated,
						onAfterClose: () => $scope.loading = false
					});
		        }else if(responseI == 8){
					var translated = $translateThis('Waiver Required!Portal');
					var waiverHref = window.location.origin + '/waiver/embedregistration?GymID=' + gymid + '&NameSpace=' + namespace + '&Redirect=/account/embedgroupschedule';
					Swal.fire({
						type: 'warning',
						title: translated,
						showCancelButton: true,
					}).then(function(result) {
						if (result.value) {
							window.location.href = waiverHref;
						}else{
							$timeout(function() {
								$scope.formLoaded = true;
								$scope.loading = false;
							}, 1);
						}
					});
				}else if(responseI == 9) {
					let maxResPerDay = $scope.classSettings.MaxReservationsPerDay;
					let translated = $translateThis($scope.joinEventResponse, {value: maxResPerDay});

					Swal.fire({
						type: 'warning',
						title: translated,
						onAfterClose: () => $scope.loading = false
					});
				}else if(responseI == 10){
					let translated = $translateThis($scope.joinEventResponse);
					
					if($scope.Client.BanBooking && $scope.unBanPrice > 0){
						Swal.fire({
							type: 'warning',
							title: translated,
							showCancelButton: true,
							confirmButtonText: 'Unban',
						}).then((result) => {
							/* Read more about isConfirmed, isDenied below */
							if (result.value) {
								$('#unBanModal').modal('show');
								$('#eventScheduleModal').modal('hide');
							}
						})
					}else{
						Swal.fire({
							type: 'warning',
							title: translated
						});
					}

					$scope.loading = false;
				}else{
		        	let translated = $translateThis($scope.joinEventResponse);
					Swal.fire({
						type: 'warning',
						title: translated,
						onAfterClose: () => $scope.loading = false
					});
		        }
		    }).error(function () {

				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated,
				});

		        $('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
		        $scope.formLoaded = true;
		        $scope.loading = false;
		    });
		}
	}

	function generateElavon(){
		let dataObject = prepareDataToSned();
		dataObject.Language = lang;
		
		$http({
			method: 'POST',
			url: '/private/GenerateElavonToken',
			data: dataObject
		}).success(function (data) {

			openLightbox(data.ElavonToken)
			
		}).error(function (error) {
			let translated = $translateThis('ERROR');
			Swal.fire({
				type: 'warning',
				title: translated,
			});

			$('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
			$scope.formLoaded = true;
			$scope.loading = false;
		});
	}

	function openLightbox(token) {
		$scope.paymentElavon = {};
        var paymentFields = {
            ssl_txn_auth_token: token
        };
        var callback = {
            onError: function (error) {
                Swal.fire({
                    type: 'warning',
                    title: 'error',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.loading = false; 
                        });
                    })
                });

                showResult("error", error,token);
            },
            onCancelled: function () {
                // showResult("cancelled", "",token);
                Swal.fire({
                    type: 'warning',
                    title: 'Cancelled',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.loading = false; 
                        });
                    })
                });
            },
            onDeclined: function (response) {
                showResult("declined", JSON.stringify(response, null, '\t'), token);
                Swal.fire({
                    type: 'warning',
                    title: 'Declined',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.loading = false; 
                        });
                    })
                });
            },
            onApproval: function (response) {			
				$scope.paymentElavon.ElavonTransactionID = response.ssl_txn_id;
				$scope.paymentElavon.ElavonOrderID = response.ssl_invoice_number;
				$scope.joinEvent();

                // showResult("approval", JSON.stringify(response, null, '\t'),token);
            }
        };
        PayWithConverge.open(paymentFields, callback);
        return false;
	}

	function showResult(status, msg, token) {
		console.log(status, msg)

		let url = '/membership/SaveElavonError/';
		let dataObject = {
			Token: token,
			Status: status,
			ExceptionText: msg,
			NameSpace: namespace
		}

		$http({
			method: 'POST',
			url: url,
			data: dataObject
		});
	}

	function generatePaymob(){

		let dataObject = prepareDataToSned();
		dataObject.Language = lang;
		
		$http({
			method: 'POST',
			url: '/private/GeneratePaymobURL',
			data: dataObject
		}).success(function (data) {
			if(data != 'Error'){
				let paymoblink = data;
                window.location.href = paymoblink;
			}else{
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated,
				});

		        $('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
		        $scope.formLoaded = true;
		        $scope.loading = false;
			}
			console.log(data);
		}).error(function (error) {
			let translated = $translateThis('ERROR');
			Swal.fire({
				type: 'warning',
				title: translated,
			});

			$('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
			$scope.formLoaded = true;
			$scope.loading = false;
		});
	}

	
	function generateCpay(){

		let dataObject = prepareDataToSned();
		dataObject.Language = lang;
		
		$http({
			method: 'POST',
			url: '/private/GenerateCPayValues',
			data: dataObject
		}).success(function (data) {
			if(data != 'Error'){
				post_to_url(data, 'post', data.PaymentUrl);
			}else{
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated,
				});

		        $('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
		        $scope.formLoaded = true;
		        $scope.loading = false;
			}
			console.log(data);
		}).error(function (error) {
			let translated = $translateThis('ERROR');
			Swal.fire({
				type: 'warning',
				title: translated,
			});

			$('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
			$scope.formLoaded = true;
			$scope.loading = false;
		});
	}

	function generateXendit(){

		let dataObject = prepareDataToSned();
		dataObject.Language = lang;
		
		$http({
			method: 'POST',
			url: '/private/GenerateXenditValues',
			data: dataObject
		}).success(function (data) {
			if(data.IsSuccess == true){
				window.location.href = data.PaymentLinkUrl;
			}else{
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: data.ErrorMessage,
				});

		        $('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
		        $scope.formLoaded = true;
		        $scope.loading = false;
			}
			console.log(data);
		}).error(function (error) {
			let translated = $translateThis('ERROR');
			Swal.fire({
				type: 'warning',
				title: translated,
			});

			$('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
			$scope.formLoaded = true;
			$scope.loading = false;
		});
	}

	function generateMyPos(){

		let dataObject = prepareDataToSned();
		dataObject.Language = lang;
		
		$http({
			method: 'POST',
			url: '/private/GenerateMyPosValues',
			data: dataObject
		}).success(function (data) {
			if(data != 'Error'){
				post_to_url(data, 'post');
			}else{
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated,
				});

		        $('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
		        $scope.formLoaded = true;
		        $scope.loading = false;
			}
			console.log(data);
		}).error(function (error) {
			let translated = $translateThis('ERROR');
			Swal.fire({
				type: 'warning',
				title: translated,
			});

			$('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
			$scope.formLoaded = true;
			$scope.loading = false;
		});
	}

	function generateNetcash(){

		let dataObject = prepareDataToSned();
		dataObject.Language = lang;
		
		$http({
			method: 'POST',
			url: '/private/GenerateNetCashValues',
			data: dataObject
		}).success(function (data) {
			if(data != 'Error'){
				post_to_url(data, 'post', 'https://paynow.netcash.co.za/site/paynow.aspx');
			}else{
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated,
				});

		        $('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
		        $scope.formLoaded = true;
		        $scope.loading = false;
			}
			console.log(data);
		}).error(function (error) {
			let translated = $translateThis('ERROR');
			Swal.fire({
				type: 'warning',
				title: translated,
			});

			$('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
			$scope.formLoaded = true;
			$scope.loading = false;
		});
	}

	function post_to_url(params, method, url) {
		let path = $scope.classSettings.MyPosTestingMode ? 'https://www.mypos.com/vmp/checkout-test' : 'https://www.mypos.com/vmp/checkout';
		if(url){
            path = url;
        }
		method = method || "post";
	
		var form = document.createElement("form");
		form.setAttribute("method", method);
		form.setAttribute("action", path);
	
		for(var key in params) {
			if(params.hasOwnProperty(key)) {
				var hiddenField = document.createElement("input");
				hiddenField.setAttribute("type", "hidden");
				hiddenField.setAttribute("name", key);
				hiddenField.setAttribute("value", params[key]);
	
				form.appendChild(hiddenField);
			 }
		}
	
		document.body.appendChild(form);
		form.submit();
	}

	$scope.closePopup = function () {
		$('.modal').modal('hide');
		$scope.resetForm();
		$scope.formLoaded = true;
	}

	$scope.resetForm = function () {
		$('#optionClassBookingMembership').removeClass("hide");
		$('.modal .popup-body').find('input').val('');
		$scope.smodal = {paymentMethod: null, email: ''};
		$('#selectPaymentMethod').addClass('disabled');
		$scope.modalPrice = null;
		$scope.clientGroupMemberSel = 0;
		$scope.paymentElavon = {};
	}

	$('#eventScheduleModal').on('hidden.bs.modal', function (e) {
		$scope.resetForm();
	})

	$scope.validateForm = function(){
		$('#eventScheduleModal .form-actions .button').removeClass('disabled');
	}

	// CheckWaiver(string Email, int PublicEventID, int GymID, string Namespace)

	function checkWaiver(){

		let dataObject = {
			Namespace: namespace,
			GymID: gymid,
			PublicEventID: $scope.PublicEventID,
			Email: $scope.Client.Email
		}
		
		$http({
			method: 'POST',
			url: '/private/CheckWaiver',
			data: dataObject
		}).success(function (data) {
			if(data.IsWaiverRequired){
			// if(data == 'Waiver Required!'){
				
				let translated = $translateThis('Waiver Required!Portal');
				if(data.WaiverTitle){
					translated = $translateThis('Waiver Required WaiverName!', { waiverName: data.WaiverTitle });
				}

				let waiverHref = window.location.origin + '/waiver/embedregistration?GymID=' + gymid + '&NameSpace=' + namespace + '&Redirect=/Schedulev2/EmbedGroupSchedule';
				Swal.fire({
					type: 'warning',
					title: translated,
					showCancelButton: true,
				}).then(function(result) {
					if (result.value) {
						window.location.href = waiverHref;
					}else{
						$timeout(function() {
							$scope.formLoaded = true;
							$scope.loading = false;
						});
					}
				});
			}else{
				$scope.loading = false;
			}
		}).error(function (error) {
			$scope.loading = false;
		});
	}

	// Check Valid Membership
	// HasValidMembership(int ClientID, int ScheduleID, int GymID, string Namespace)

	function checkHasValidMembership(member){
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			ScheduleID: $scope.modalVisit.ID,
			ClientID: $scope.client.ClientID
		}

		if(member){
			dataObject.ClientID = member.ClientID
		}
		
		$http({
			method: 'GET',
			url: '/private/HasValidMembership?Namespace=' + namespace + '&GymID=' + gymid + '&ScheduleID=' + $scope.modalVisit.ID + '&ClientID=' + dataObject.ClientID,
			data: dataObject
		}).success(function (data) {

			if(data == 'true' || data == 'True' || data == true){
				$scope.smodal.paymentMethod = '1';
				$("#optionClassBookingMembership").removeAttr("disabled");
				$('#selectPaymentMethod').addClass('disabled');
			}else{
				$timeout(function() {
					$scope.smodal.paymentMethod = '';
				});
				$('#selectPaymentMethod').removeClass('disabled');
				$("#optionClassBookingMembership").attr("disabled", "disabled");
			}
		}).error(function () {
		});
	}

	$scope.eventLink = function(event){

		$scope.peopleWaiting = 0;
		$scope.modalVisit = event;

		if($scope.Client.BanBooking && $scope.unBanPrice > 0){
			let translated = $translateThis('Your access to the booking system has been suspended due to non-compliance with the rules of the sports center. Please contact reception.');
			Swal.fire({
				type: 'warning',
				title: translated,
				showCancelButton: true,
				confirmButtonText: 'Unban',
			}).then((result) => {
				/* Read more about isConfirmed, isDenied below */
				if (result.value) {
					$('#unBanModal').modal('show')
				}
			})
		}else{
			checkMaxPeopleArea(event.ID);
		}
	}

	function checkMaxPeopleArea(eventID){

		let dataObject = {
			ScheduleContentID: eventID,
			GymID: gymid,
			Namespace: namespace
		}

		$http({
			method: 'POST',
			url: '/private/CheckMaxPeopleAreaReached',
			data: dataObject
		}).success(function (data) {

			if( data == 0 ){

				if($scope.modalVisit.FullCapacity){
					if($scope.modalVisit.WaitingList && !$scope.modalVisit.Cancelled){
						$('#waitingModal').modal('show');
					}else{
						$scope.joinModal($scope.modalVisit.ID);
					}
				}else{
					if( $scope.modalVisit.AheadBooking && $scope.modalVisit.BookOnline == true && $scope.modalVisit.AheadBooking && !$scope.modalVisit.Cancelled){
	
						checkForWaitingPeople()
					}else{
						$scope.joinModal($scope.modalVisit.ID);
					}
				}

			}else{
				if($scope.modalVisit.WaitingList && !$scope.modalVisit.Cancelled){
					$('#waitingModal').modal('show');
				}else{
					let translated = $translateThis('Area capacity MaxPeople reached');
					Swal.fire({
						type: 'warning',
						title: translated
					});
				}
			}

		}).error(function (error) {
		});
	}

	function checkForWaitingPeople(eventID){
		let dataObject = {
			ScheduleContentID: $scope.modalVisit.ID,
			GymID: gymid,
			Namespace: namespace
		}
		$http({
			method: 'POST',
			url: '/private/CheckForWaitingPeople',
			data: dataObject
		}).success(function (data) {

			$scope.peopleWaiting = data;
			if( data > 0 ){
				$('#waitingModal').modal('show');
			}else{
				$scope.joinModal($scope.modalVisit.ID);
			}

		}).error(function (error) {
		});
	}

	$scope.joinWaitingList = function(event){
		let dataObject = {
			Namespace: namespace,
			GymID: gymid,
			Id: event.ID,
			Email: $scope.client.Email,
			FirstName: $scope.Client.FirstName,
			LastName: $scope.Client.LastName,
			Telephone: $scope.Client.Telephone,
			Date: moment(event.NewDate).toISOString(),
			VisitName: event.VisitName,
			Language: lang
		}

		$http({
			method: 'POST',
			url: '/private/JoinWaitingList',
			data: dataObject
		}).success(function (data) {

			//0:everything ok; 1:no client found; 2:cannot add to waiting list; 3:error;4 already in the same waiting list; 7:no event found
			let response = data;

			if(response == 0){
				let translated = $translateThis('Thank you for joining the waitlist. You will receive an email if space becomes available.');
				Swal.fire({
					type: 'success',
					title: translated,
					onAfterClose: () => $scope.closePopup()
				});
			}else if(response == 1){
				let translated = $translateThis('There is no customer with this email. Please contact reception.');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: () => $scope.closePopup()
				});
			}else if(response == 2){
				let translated = $translateThis('Cannot add to waiting list');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: () => $scope.closePopup()
				});
			}else if(response == 3){
				let translated = $translateThis('Error');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: () => $scope.closePopup()
				});
			}else if(response == 4){
				let translated = $translateThis('You are already in the waitlist. We will send you an email if space becomes available');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: () => $scope.closePopup()
				});
			}else if(response == 5){
				let translated = $translateThis('Your access to the booking system has been suspended due to non-compliance with the rules of the sports center. Please contact reception.');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: () => $scope.closePopup()
				});
			}else if(response == 7){
				let translated = $translateThis('no event found');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: () => $scope.closePopup()
				});
			}

		}).error(function (error) {
		});
	}

	function getClientMembership(status = null){

		let dataObject = {
			Namespace: namespace,
			ClientID: $scope.client.ClientID,
		}
		
		$http({
			method: 'POST',
			url: '/Membership/GetClientGroupMembers',
			data: dataObject
		}).success(function (data) {
			$scope.clientGroupMembers = data;
			if(data.length > 1){
			}else{
				if(data.length == 1 && data[0].ClientID == $scope.client.ClientID){
					$scope.clientGroupMembers = [];
				}
				if(status == 'joinModal'){
					checkHasValidMembership();
				}
				if($scope.modalVisit && $scope.modalVisit.AgeRestriction){
					if($scope.client && $scope.client.Birthday)
						checkAgeRestriction($scope.client);
				}
				$scope.getClientServices();
			}

		}).error(function (error) {
			console.log(error);
		});
	}

	$scope.ageRestrictionStatus = true;
	function checkAgeRestriction(user, groupMember = false){
		if(user){
			let birthDate;
			if (groupMember) {
				const match = /\/Date\((-?\d+)\)\//.exec(user.Birthdate);
				birthDate = match ? new Date(parseInt(match[1])) : new Date(user.Birthdate);
			} else {
				birthDate = new Date(user.Birthday);
			}
			const now = new Date();
			let age = now.getFullYear() - birthDate.getFullYear();
			const monthDiff = now.getMonth() - birthDate.getMonth();
			if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birthDate.getDate())) {
				age--;
			}

			console.log(age);

			const minAge = $scope.modalVisit.MinAge;
			const maxAge = $scope.modalVisit.MaxAge;

			if (minAge === 0) {
				$scope.ageRestrictionStatus = age <= maxAge;
			} else if (maxAge === 0) {
				$scope.ageRestrictionStatus = age >= minAge;
			} else {
				$scope.ageRestrictionStatus = age >= minAge && age <= maxAge;
			}
		}else{
			$scope.ageRestrictionStatus = false;
		}
	}

	// Join Modal
	$scope.joinModal = function (visitId) {
		$scope.modalLoading = true;
		$scope.loading = true;
		$scope.noActivePayment = false;
		$scope.visitProducts = [];
		// $scope.clientGroupMembers = [];
		var result = $.grep($scope.originalData, function (e) { return e.ID == visitId; });

		if ( result.length > 0 ) {
			$scope.modalVisit = result[0];
			$scope.PublicEventID = result[0].PublicEventID;

			var dayOfWeek = $filter('date')($scope.modalVisit.NewDate, 'EEEE');
			var compiledeHTML = $compile("<span translate-date-object><span class='day ng-binding'>" + dayOfWeek + "</span></span>")($scope);
			$(".dayofweekn").html(compiledeHTML);


			var now = new Date();

			if (now < $scope.modalVisit.HoursBeforeBooking) {
				$('#eventScheduleModal').modal('show');

				if($scope.modalVisit.BookOnline == true && $scope.modalVisit.AheadBooking && !$scope.modalVisit.Cancelled && !$scope.modalVisit.FullCapacity){
					getEventPrice();
					if($scope.client){
						getClientMembership('joinModal');
					}
				
					setTimeout(function () {
						var dataObject = {
							Namespace: namespace,
							GymID: gymid,
							ID: visitId
						}

						$http({
							method: 'GET',
							url: '/api/public/GetEqipment?nameSpace=' + namespace + '&gymId=' + gymid + '&ID=' + visitId,
							data: dataObject
						}).success(function (data) {
							$scope.visitProducts = data;
							$scope.modalLoading = false;
							checkWaiver();
						}).error(function () {
						});

						// $('#eventScheduleModal .form-actions .button').removeClass('disabled');
					}, 10);	
				}
			} else {

				let translated = $translateThis('Its too late to join this event.');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: () => $scope.closePopup()
				});
			}
		}
	}

	function getEventPrice(){
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			id: $scope.PublicEventID,
		}
		
		$http({
			method: 'GET',
			url: '/private/GetPublicEventPrice?Namespace=' + namespace + '&GymID=' + gymid + '&id=' + $scope.PublicEventID,
			data: dataObject
		}).success(function (data) {
			$scope.modalPrice = data;


			// console.log($('#selectPaymentMethod option.ng-scope'), $('#selectPaymentMethod option.ng-scope').length);

			if( $('#selectPaymentMethod option.ng-scope').length == 1){
				$scope.smodal.paymentMethod = $('#selectPaymentMethod option.ng-scope').val();
				$scope.paymentChange();
			}

		}).error(function () {
		});
	}

	$scope.getAttendingClients = function(item){

		if(!item.AttendingClients){
			$scope.modalLoading = true;

			var dataObject = {
				Namespace: namespace,
				GymID: gymid,
				ScheduleID: item.ID,
				AreaID: item.AreaID
			}

			$http({
				method: 'GET',
				url: '/private/GetAttendingClients?Namespace=' + namespace + '&GymID=' + gymid + '&ScheduleID=' + item.ID + '&AreaID=' + item.AreaID,
				data: dataObject
			}).success(function (data) {
				item.attedingCleints = data;

				$scope.clientsData = item.attedingCleints;
				$('#attendantsModal').modal('show');

			}).error(function () {
				// console.log('error');
			});
		}else{
			$('#attendantsModal').modal('show');
			$scope.clientsData = item.AttendingClients
		}
	}


	// $('.popup-wrapper .close, .popup-wrapper .popup-overlay').on('click', function (e) {
	// 	e.preventDefault();
	// 	$('.popup-wrapper, #shcedule-popup .popup, #shcedule-popup .error-msg, #shcedule-popup .success-msg').removeClass('show');
	// 	$('#shcedule-popup .popup-body').removeClass('show-success show-error');
	// 	$scope.resetForm();
	// })

	// Datepickers
	$scope.currentLang = $translate.proposedLanguage() || $translate.use();

	schedule_from.datepicker({
		changeMonth: true,
		changeYear: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function (dateText, inst) {
			var date = dateText;
			schedule_to.datepicker("option", "minDate", date);


			if ($scope.gym[0].Culture != 'en-US') {
				var res = date.split("/");
				var date = res[1] + '/' + res[0] + '/' + res[2];
			}

			$scope.scheduleStartDate = date;
		}
	});

	schedule_to.datepicker({
		changeMonth: true,
		changeYear: true,
		numberOfMonths: 2,
		minDate: 1,
		onSelect: function (dateText, inst) {
			var date = dateText;
			schedule_from.datepicker("option", "maxDate", date);

			if ($scope.gym[0].Culture != 'en-US') {
				var res = date.split("/");
				var date = res[1] + '/' + res[0] + '/' + res[2];
			}

			var tomorrow = new Date(date);
			tomorrow.setDate(tomorrow.getDate() + 1);

			$scope.scheduleEndDate = tomorrow;
		}
	});

	$('.ui-datepicker').addClass('notranslate');

	if($scope.classSettings.ShowScheduleDaysAhead > 0 ){
		let days = $scope.classSettings.ShowScheduleDaysAhead - 1;
		let today = new Date();
		today.setDate(today.getDate() + days);
		maxDate = new Date(today);

		schedule_from.datepicker("option", "maxDate", maxDate);
		schedule_to.datepicker("option", "maxDate", maxDate);

	}

	if ($scope.currentLang == 'bg') {
		$('#schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['bg']);
	}else if($scope.currentLang == 'es' || $scope.currentLang == 'esc' || $scope.currentLang == 'esm'){
		$('#schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['es']);
	}else if($scope.currentLang == 'pt'){
		$('#schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['pt']);
	}else if($scope.currentLang == 'it'){
		$('#schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['it']);
	}else if($scope.currentLang == 'ro'){
		$('#schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['ro']);
	}else if($scope.currentLang == 'lt'){
		$('#schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['lt']);
	}else if($scope.currentLang == 'id'){
		$('#schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['id']);
	}else if($scope.currentLang == 'de'){
		$('#schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['de']);
	}else if($scope.currentLang == 'mk'){
		$('#schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['mk']);
	}else{
		$('#schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['en']);
	}

	if ($scope.gym[0].Culture == 'en-US') {
		$('#schedule_to, #schedule_from').datepicker( "option", "dateFormat", "mm/dd/yy" );
	} else {
		$('#schedule_to, #schedule_from').datepicker( "option", "dateFormat", "dd/mm/yy" );
	}


	function getDate(element) {
		var date;
		try {
			date = $.datepicker.parseDate(dateFormat, element.value);
		} catch (error) {
			date = null;
		}
		return date;
	}


	// $(document).on('click', '.dd .dd-head', function (e) {
	// 	e.preventDefault();
	// 	if(!$scope.paymentLocked)
	// 		$(this).parent('.dd').toggleClass('show');
	// });

	// $(document).click(function (e) {
	// 	if ($(e.target).closest('.dd').length === 0 && $('.dd').is('.show')) {
	// 		$('.dd').removeClass('show');
	// 	}
	// });

	// $(document).on('click', '#shcedule-popup .dd-field', function () {
	// 	var content = $(this).find('label').html();
	// 	$scope.paymentMethod = $(this).find('input').val();
	// 	$('#shcedule-popup .dd-head').html(content);
	// 	$('#shcedule-popup .dd').removeClass('show');
	// 	paymentChange();
	// })



	$('.schedule-wrapper .filter-section .date-col i').on('click', function (e) {
		$(this).parent().find('input').datepicker('show');
	})

	$(window)
	.on('load', function(){
		resizeAndDatepicker();
	})
	.on('resize', function(){
		resizeAndDatepicker();
	})

	//  Check Window Size and change datepicker options
	function resizeAndDatepicker(){
		var windowWidth = $(window).width();

		if ( windowWidth <= 768 ) {
			schedule_from.datepicker("option", "numberOfMonths", 1);
			schedule_to.datepicker("option", "numberOfMonths", 1);
		}else{
			schedule_from.datepicker("option", "numberOfMonths", 2);
			schedule_to.datepicker("option", "numberOfMonths", 2);
		}
	}

}]);